/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Part } from './Part';
import {
    PartFromJSON,
    PartFromJSONTyped,
    PartToJSON,
} from './Part';

/**
 * Optional header denotation
 * @export
 * @interface Denotation
 */
export interface Denotation {
    /**
     * All individual parts making up this denotation, to be separated with a whitespace each
     * @type {Array<Part>}
     * @memberof Denotation
     */
    parts: Array<Part>;
}

/**
 * Check if a given object implements the Denotation interface.
 */
export function instanceOfDenotation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parts" in value;

    return isInstance;
}

export function DenotationFromJSON(json: any): Denotation {
    return DenotationFromJSONTyped(json, false);
}

export function DenotationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Denotation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parts': ((json['parts'] as Array<any>).map(PartFromJSON)),
    };
}

export function DenotationToJSON(value?: Denotation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parts': ((value.parts as Array<any>).map(PartToJSON)),
    };
}

